import fetch from "isomorphic-fetch";
import { useHistory } from "react-router-dom";
import { API } from "../config";
import { getCookie, userSessionExpired } from "./auth";
const Notifications = () => {
  const history = useHistory();

  const viewAllNotifications = (id) => {
    return fetch(`${API}/notifications`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then((response) => {
        userSessionExpired(response, history);
        return response.json();
      })
      .catch((err) => err);
  };



  return {
   viewAllNotifications  
};
};

export default Notifications;
